import { render, staticRenderFns } from "./link-config.vue?vue&type=template&id=70dedefa&scoped=true"
import script from "./link-config.vue?vue&type=script&lang=js"
export * from "./link-config.vue?vue&type=script&lang=js"
import style0 from "./link-config.vue?vue&type=style&index=0&id=70dedefa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70dedefa",
  null
  
)

export default component.exports